var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-pt-login',{staticClass:"pt-pt-login__page"})
}
var staticRenderFns = []

export { render, staticRenderFns }